import React from 'react';
export function Footer() {
  return <footer className="bg-gradient-to-b from-transparent to-blue-950/50 backdrop-blur-sm border-t border-blue-400/20 py-12 px-4 mt-16" data-id="element-51">
      <div className="max-w-6xl mx-auto" data-id="element-52">
        <div className="text-center space-y-6" data-id="element-53">
          <div className="text-blue-100" data-id="element-54">
            <p className="font-semibold text-white text-lg mb-2" data-id="element-55">
              30 Días para una Fe que Transforma
            </p>
            <p className="text-sm" data-id="element-56">
              Reconecta con tu paz interior y vuelve a sentir a Dios
            </p>
          </div>

          <div className="flex flex-wrap justify-center gap-6 text-sm" data-id="element-57">
            <a href="#" className="text-blue-300 hover:text-yellow-400 transition-colors" data-id="element-58">
              Políticas de Privacidad
            </a>
            <span className="text-blue-600" data-id="element-59">|</span>
            <a href="#" className="text-blue-300 hover:text-yellow-400 transition-colors" data-id="element-60">
              Términos y Condiciones
            </a>
            <span className="text-blue-600" data-id="element-61">|</span>
            <a href="#" className="text-blue-300 hover:text-yellow-400 transition-colors" data-id="element-62">
              Garantía
            </a>
            <span className="text-blue-600" data-id="element-63">|</span>
            <a href="#" className="text-blue-300 hover:text-yellow-400 transition-colors" data-id="element-64">
              Contacto
            </a>
          </div>

          <div className="pt-6 border-t border-blue-400/20" data-id="element-65">
            <p className="text-blue-300 text-sm" data-id="element-66">
              Copyright © 2025 Fe Viva Ediciones™ · Todos los derechos
              reservados
            </p>
          </div>

          <div className="text-blue-400 text-xs max-w-2xl mx-auto" data-id="element-67">
            <p data-id="element-68">
              Este contenido espiritual es complementario y no reemplaza
              consejos médicos, psicológicos o profesionales. Si experimentas
              problemas de salud mental, consulta con un profesional calificado.
            </p>
          </div>
        </div>
      </div>
    </footer>;
}